import { axios } from '@/utils/request'
const api = {
  source: '/order',
  enterprise: '/enterprise'
}

// 获取安装类型
export function selectInstallType(parameter) {
  return axios({
    url: '/basicdata/QrCode/selectInstallType',
    method: 'get',
    params: parameter
  })
}

export function selectOrderType(parameter) {
  return axios({
    url: '/basicdata/QrCode/selectOrderType',
    method: 'get',
    params: parameter
  })
}

//编辑客户下单订单
export function editCustomerOrder(parameter) {
  return axios({
    url: api.source + '/customer/editCustomerOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 查询安装要求信息字典表
export function getDemandInfo(parameter) {
  return axios({
    url: '/system/dict/data/listNoPermission',
    method: 'get',
    params: parameter
  })
}
// 查询商品信息字典表
export function getGoodsInfo(parameter) {
  return axios({
    url: '/system/dict/data/listNoPermission',
    method: 'get',
    params: parameter
  })
}
// 订单详情 查询企业品牌，渠道，信息来源
export function selectEnterpriseinfo(parameter) {
  return axios({
    url: '/enterprise/source/selectEnterpriseinfo',
    method: 'get',
    params: parameter
  })
}
// 查询匹配订单信息
export function getsearchMatchOrder(parameter) {
  return axios({
    url: api.source + '/relation/searchMatchOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getcheckOrderUrgent(parameter) {
  return axios({
    url: '/order/orderStatus/checkOrderUrgent',
    method: 'post',
    params: parameter
  })
}
export function getenterpriseInstallTypes(parameter) {
  return axios({
    url: '/enterprise/enterpriseInstallTypes/list',
    method: 'get',
    params: parameter
  })
}
export function getEnterpriseContactsById(parameter) {
  return axios({
    url: '/order/order/getEnterpriseContactsById',
    method: 'get',
    params: parameter
  })
}
export function gettemplateselectInfo(parameter) {
  return axios({
    url: '/basicdata/template/selectInfo',
    method: 'get',
    params: parameter
  })
}
export function getBaseInfoForOrder(parameter) {
  return axios({
    url: '/enterprise/management/getBaseInfoForOrder',
    method: 'get',
    params: parameter
  })
}
// 验证订单
export function getverificationOrder(parameter) {
  return axios({
    url: '/order/order/verificationOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单添加配件查询企业可用配件
export function getqueryEnterpriseAccessory(parameter) {
  return axios({
    url: api.source + '/accessory/queryEnterpriseAccessory',
    method: 'get',
    params: parameter
  })
}
// 查询企业可分配仓库
export function getqueryEnterpriseStock(parameter) {
  return axios({
    url: api.enterprise + '/enterpriseAccessory/queryEnterpriseStock',
    method: 'get',
    params: parameter
  })
}
// 订单添加配件查询配件信息和金额
export function getqueryEnterpriseAccessoryPrice(parameter) {
  return axios({
    url: '/order/accessory/queryEnterpriseAccessoryPrice',
    method: 'get',
    params: parameter
  })
}
// 模板新增页面的回显
export function getinfoList(parameter) {
  return axios({
    url: `/basicdata/template/infoList/${parameter}`,
    method: 'get'
  })
}
// 企业带出寄回要求接口
export function getSendBackList(parameter) {
  return axios({
    url: '/enterprise/management/getSendBackList',
    method: 'get',
    params: parameter
  })
}
// 安装模板列表
export function gettemplatelist(parameter) {
  return axios({
    url: '/basicdata/template/list',
    method: 'get',
    params: parameter
  })
}
// 查询购买渠道下拉框
export function getselectChannel(parameter) {
  return axios({
    url: api.enterprise + '/channel/selectChannel',
    method: 'get',
    params: parameter
  })
}
// 查询企业要求图片列表
export function getPiclist(parameter) {
  return axios({
    url: api.enterprise + '/demandPic/list',
    method: 'get',
    params: parameter
  })
}
// 查询企业要求列表
export function getdemandlist(parameter) {
  return axios({
    url: api.enterprise + '/demand/list',
    method: 'get',
    params: parameter
  })
}
// 查询信息来源下拉框
export function getselectSource(parameter) {
  return axios({
    url: api.enterprise + '/source/selectSource',
    method: 'get',
    params: parameter
  })
}
// 查询企业下拉框
export function getselectCombox(parameter) {
  return axios({
    url: '/enterprise/management/selectCombox',
    method: 'get',
    params: parameter
  })
}
// 区
export function getanalysisText(parameter) {
  return axios({
    url: api.source + '/order/analysisText',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 订单关联接口
export function addOrderRelation(parameter) {
  return axios({
    url: api.source + '/relation/addOrderRelation',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 新增订单
export function getaddOrder(parameter) {
  return axios({
    url: api.source + '/order/addOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 新增企业订单
export function getaddqyOrder(parameter) {
  return axios({
    url: api.source + '/merchantOrder/merchantAddOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getSourceList(parameter) {
  return axios({
    url: api.source + '/order/orderListSearch',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export const sourceExport = api.source + '/export'
